import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "Wishlist-view" }
const _hoisted_2 = { class: "big-list" }
const _hoisted_3 = { class: "count" }

import { WishlistItem as Wishlist } from '@/models/wishlist.model';
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { Actions } from '@/store';
import WishlistItem from './WishlistItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WishlistList',
  setup(__props) {

const store = useStore();
const wishlist = computed<Wishlist[]>(() => store.state.wishlist);
const wishlistCount = computed<string>(() => {
  return `${wishlist.value.length} Item${
    wishlist.value.length === 1 ? '' : 's'
  }`;
});

onMounted(() => {
  store.dispatch(Actions.GetWishlist);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("p", null, [
        _createVNode(_component_router_link, { to: "/wishlist/add" }, {
          default: _withCtx(() => [
            _createTextVNode("Add an item to the wishlist")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(wishlistCount)), 1),
      _createElementVNode("ol", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wishlist), (item) => {
          return (_openBlock(), _createBlock(WishlistItem, {
            key: item.name,
            item: item
          }, null, 8, ["item"]))
        }), 128))
      ])
    ])
  ]))
}
}

})